<template>
  <el-dialog
    :title="l('请输入您的企业信息')"
    v-if="DialogVisible"
    :visible.sync="DialogVisible"
    class="large-padding-dialog"
    :close-on-click-modal="false"
    :before-close="Hide"
  >
    <el-form
      :model="DialogFormData"
      ref="DialogFormData"
      :rules="dialogRules"
      :class="[{ View: Type == 'View' }]"
    >
      <el-row :gutter="20">
        <el-col>
          <el-form-item :label="l('企业名称')" prop="pre_company_name">
            <el-input
              v-model="DialogFormData.pre_company_name"
              :placeholder="l('请输入') + l('企业名称')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item :label="l('主营业务')" prop="pre_business_tag_id">
            <el-select
              v-model="DialogFormData.pre_business_tag_id"
              :placeholder="l('请选择') + l('主营业务')"
            >
              <el-option
                v-for="item of $store.state.basicInfo.tagList.pre_business"
                :key="item.id"
                :label="l(item.name)"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col>
          <el-form-item
            :label="l('邀请码') + ' (' + l('非必填') + ')'"
            prop="invite_mobile"
          >
            <el-input
              v-model="DialogFormData.invite_mobile"
              :placeholder="l('请输入') + l('邀请码')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{ l("取 消") }}</el-button>
      <el-button v-if="Type == 'View'" type="warning" @click="Type = 'Edit'">{{
        l("修 改")
      }}</el-button>
      <el-button
        v-if="Type == 'Create' || Type == 'Edit'"
        type="primary"
        @click="submitForm"
        >{{ l("确 定") }}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "PersonalInfo",
  mixins: [dialogMixin],
  data() {
    return {
      Type: "Create",
      DialogFormData: {
        pre_company_name: "",
        pre_business_tag_id: null,
        invite_mobile: "",
      },
      dialogRules: {
        pre_company_name: [
          {
            required: true,
            message: this.l("请输入") + this.l("企业名称"),
            trigger: "blur",
          },
        ],
        pre_business_tag_id: [
          {
            required: true,
            message: this.l("请选择") + this.l("主营业务"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    BeforeShow() {
      this.DialogFormData = {
        pre_company_name: this.$store.state.session.user.pre_company_name,
        pre_business_tag_id: this.$store.state.session.user.pre_business_tag_id,
      };
    },
    submitForm() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }

        this.axios
          .post(`/api/account/pre_login_info/`, this.DialogFormData)
          .then((data) => {
            this.$emit("submitDialog");
            this.Hide();
          });
      });
    },
  },
};
</script>


<style scoped lang="scss">
</style>

